export const apiEndpoint = window.API_ENDPOINT || "https://api.rentujemy.com";
export const GOOGLE_MAPS_API = "AIzaSyAcqK4i-BsVUFWzHNyZgJ7mjD92oUyRD0c";
export const GOOGLE_ANALYTICS_ID = "G-01E7R2TW4S";
